<template>
  <!-- 新建外发 -->
  <div class="pagesBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="saveConfirm('baseInFormRef')">保存</el-button>
    </div>
    <div class="formbox">
      <el-form :model="baseInForm" :rules="rulesA" ref="baseInFormRef" label-width="120px" class="glo_formBox">
        <div class="teSu">
          <el-form-item label="运单号:">
            <el-input v-model.trim="waybillNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-button class="glo_bgcMainColor formBtns" @click="getData()">搜索</el-button>
        </div>
        <el-form-item label="外发提货方式:" prop="receiveMethodConfDictId">
          <el-select v-model="baseInForm.receiveMethodConfDictId" placeholder="请选择" clearable remote>
            <el-option v-for="item in send_method_list" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否入仓:" prop="isIntoStorage">
          <el-select v-model="baseInForm.isIntoStorage" placeholder="请选择">
            <el-option v-for="item in yesOrNoList" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入仓仓库:" v-if="baseInForm.isIntoStorage == '1'" prop="intoStorageId">
          <el-select v-model="baseInForm.intoStorageId" placeholder="请选择" clearable>
            <el-option v-for="item in storageList" :key="item.documentId" :label="item.name" :value="item.documentId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="承运公司:" prop="carrierDeptId">
          <div class="twoSelect">
            <el-select v-model="baseInForm.outboundCarrierId" placeholder="请选择" clearable filterable @change="changecarrierName3" @focus="changeCarrier()" remote :remote-method="getchangeCarrier">
              <el-option v-for="item in changeCarrierList" :key="item.carrierId" :label="item.carrierName" :value="item.carrierId"></el-option>
            </el-select>
            <el-select v-model="baseInForm.carrierDeptId" placeholder="承运商网点" clearable @change="changecarrierDeptId">
              <el-option v-for="item in CarrierDeptListList2" :key="item.carrierDeptId" :label="item.deptName" :value="item.carrierDeptId"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="外发单号:" prop="outgoingNumber">
          <el-input v-model="baseInForm.outgoingNumber" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="本地联系人:" prop="contacts">
          <el-input v-model="baseInForm.contacts" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="本地电话:" prop="localPhone">
          <el-input v-model="baseInForm.localPhone" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="承运商线路:" prop="carrierLineId">
          <el-select clearable v-model="baseInForm.carrierLineId" placeholder="请选择承运商线路" @change="changeCarrierLine">
            <el-option v-for="item in CarrierLineLists" :key="item.carrierLineId" :label="item.lineName" :value="item.carrierLineId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="baseInForm.carrierLineId" label="目的地联系人:" prop="destContacts">
          <el-input v-model="baseInForm.destContacts" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="baseInForm.carrierLineId" label="目的地电话:" prop="destPhone">
          <el-input v-model="baseInForm.destPhone" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="baseInForm.carrierLineId" label="目的地地址:" prop="destAddress">
          <el-input v-model="baseInForm.destAddress" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="baseInForm.carrierLineId" label="中转地址:" prop="transferAddress">
          <el-input v-model="baseInForm.transferAddress" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="baseInForm.carrierLineId" label="中转电话:" prop="transferPhone">
          <el-input v-model="baseInForm.transferPhone" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="始发网点:" prop="startDeptId">
          <el-select v-model="baseInForm.startDeptId" placeholder="请选择" clearable>
            <el-option v-for="item in storageList" :key="item.documentId" :label="item.name" :value="item.documentId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外发日期:" prop="outgoingTime">
          <el-date-picker v-model="baseInForm.outgoingTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" default-time="12:00:00"></el-date-picker>
        </el-form-item>
        <el-form-item label="计费方式:" prop="billingMethodConfDictId">
          <el-select v-model="baseInForm.billingMethodConfDictId" placeholder="请选择" clearable @change="changeBILLMethode">
            <el-option v-for="item in out_going_billing_method_list" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外发件数:" prop="packageCount">
          <el-input v-model="baseInForm.packageCount" placeholder="请输入" type="number" @mousewheel.native.prevent clearable></el-input>
        </el-form-item>

        <el-form-item label="外发毛重(KG):" prop="grossWeight">
          <el-input v-model="baseInForm.grossWeight" placeholder="请输入" type="number" @mousewheel.native.prevent clearable></el-input>
        </el-form-item>
        <el-form-item label="外发净重(KG):" prop="netWeight">
          <el-input v-model="baseInForm.netWeight" placeholder="请输入" type="number" @mousewheel.native.prevent clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="外发重量(KG):" prop="weight">
          <el-input
            v-model="baseInForm.weight"
            placeholder="请输入"
            type="number"
            @mousewheel.native.prevent
            clearable
          ></el-input>
        </el-form-item>-->
        <el-form-item label="外发体积(m³):" prop="volume">
          <el-input v-model="baseInForm.volume" placeholder="请输入" type="number" @mousewheel.native.prevent clearable></el-input>
        </el-form-item>
        <el-form-item label="单价:" prop="unitPrice">
          <el-input v-model="baseInForm.unitPrice" placeholder="请输入" type="number" @mousewheel.native.prevent clearable @input="countBaseFee()"></el-input>
        </el-form-item>
        <el-form-item label="计费取值:" prop="billingWeight">
          <el-input v-model="baseInForm.billingWeight" placeholder="请输入" type="number" @mousewheel.native.prevent clearable @input="countBaseFee()"></el-input>
        </el-form-item>
        <el-form-item label="基本运费:" prop="basicFreight">
          <div class="disFlexs jsInput">
            <el-input v-model="baseInForm.basicFreight" placeholder="请输入" type="number" @mousewheel.native.prevent clearable @input="countWFZE()"></el-input>
            <el-button class="jsBtns glo_bgcMainColor" @click="countBaseFee()">计算</el-button>
          </div>
        </el-form-item>

        <el-form-item label="提货费:" prop="takeFee">
          <el-input v-model="baseInForm.takeFee" placeholder="请输入" type="number" @mousewheel.native.prevent clearable @input="countWFZE()"></el-input>
        </el-form-item>
        <el-form-item label="送货费:" prop="sendFee">
          <el-input v-model="baseInForm.sendFee" placeholder="请输入" type="number" @mousewheel.native.prevent clearable @input="countWFZE()"></el-input>
        </el-form-item>
        <el-form-item label="装卸费:" prop="unLoadFee">
          <el-input v-model="baseInForm.unLoadFee" placeholder="请输入" type="number" @mousewheel.native.prevent clearable @input="countWFZE()"></el-input>
        </el-form-item>
        <el-form-item label="其他费用:" prop="allOtherFee">
          <div class="disFlexs jsInput">
            <el-input v-model="baseInForm.allOtherFee" placeholder="请输入" clearable @input="countWFZE()" type="number" @mousewheel.native.prevent></el-input>
            <el-button class="jsBtns glo_bgcMainColor" @click="otherDetails()">明细</el-button>
          </div>
        </el-form-item>

        <el-form-item label="外发总额:" prop="totalFreight">
          <div class="disFlexs jsInput">
            <el-input v-model="baseInForm.totalFreight" placeholder="请输入" clearable></el-input>
            <el-button class="jsBtns glo_bgcMainColor" @click="countWFZE()">计算</el-button>
          </div>
        </el-form-item>
        <el-form-item label="是否含税:" prop="isInvoice">
          <el-select v-model="baseInForm.isInvoice" placeholder="请选择">
            <el-option v-for="item in yesOrNoList" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="税点:" prop="invoiceTaxPoint">
          <div class="disFlex">
            <el-input v-model="baseInForm.invoiceTaxPoint" placeholder="请输入" type="number" @mousewheel.native.prevent clearable @input="countSJ()" :disabled="baseInForm.isInvoice == '0'"></el-input>
            <div>(%)</div>
          </div>
        </el-form-item>
        <el-form-item label="税金:" prop="taxes">
          <div class="disFlexs jsInput">
            <el-input v-model="baseInForm.taxes" placeholder="请输入" clearable :disabled="baseInForm.isInvoice == '0'" @input="countYFZE()"></el-input>
            <el-button class="jsBtns glo_bgcMainColor" @click="countSJ()">计算</el-button>
          </div>
        </el-form-item>

        <el-form-item label="应付总额:" prop="shouldAmount">
          <div class="disFlexs jsInput">
            <el-input v-model="baseInForm.shouldAmount" placeholder="请输入" clearable></el-input>
            <el-button class="jsBtns glo_bgcMainColor" @click="countYFZE()">计算</el-button>
          </div>
        </el-form-item>
        <el-form-item label="返点:" prop="returnAmount">
          <el-input v-model="baseInForm.returnAmount" placeholder="请输入" type="number" @mousewheel.native.prevent clearable @input="countJSJE()"></el-input>
        </el-form-item>
        <el-form-item label="结算金额:" prop="settlementAmount">
          <div class="disFlexs jsInput">
            <el-input v-model="baseInForm.settlementAmount" placeholder="请输入" clearable></el-input>
            <el-button class="jsBtns glo_bgcMainColor" @click="countJSJE()">计算</el-button>
          </div>
        </el-form-item>
        <el-form-item label="摊分成本:" prop="apportionedCost">
          <el-input v-model="baseInForm.apportionedCost" placeholder="请输入" type="number" @mousewheel.native.prevent clearable></el-input>
        </el-form-item>
        <el-form-item label="开单运费:" prop="billingAmount">
          <el-input v-model="baseInForm.billingAmount" placeholder="自动获取" type="number" @mousewheel.native.prevent disabled></el-input>
        </el-form-item>
        <el-form-item label="代收货款:" prop="agentAmount">
          <el-input v-model="baseInForm.agentAmount" placeholder="自动获取" type="number" @mousewheel.native.prevent disabled></el-input>
        </el-form-item>
        <el-form-item label="到付金额:" prop="receivedAmount">
          <el-input v-model="baseInForm.receivedAmount" placeholder="自动获取" type="number" @mousewheel.native.prevent disabled></el-input>
        </el-form-item>
        <el-form-item label="外发结算方式:" prop="settlementMethodConfDictId">
          <el-select v-model="baseInForm.settlementMethodConfDictId" placeholder="请选择" clearable>
            <el-option v-for="item in out_going_settlement_method_list" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="textArea" style="width: 100%" label="外发备注:" prop="remarks">
          <el-input type="textarea" rows="3" v-model="baseInForm.remarks"></el-input>
        </el-form-item>
        <!-- <div>
          <el-checkbox v-model="baseInForm.isCarrierSettlement"
            >运单到付款由承运商代收,直接与承运商进行结算</el-checkbox
          >
        </div>-->
      </el-form>
    </div>

    <div class="glo_Table" style="margin-bottom: 20px">
      <div class="tbTit">运单信息</div>
      <el-table header-align="center" :data="tableData2" border stripe :highlight-current-row="true" show-summary>
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <template v-for="(item, index) in tabelHeadeTitle2">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 表格 -->
    <div class="glo_Table" style="margin-bottom: 20px">
      <el-table header-align="center" :data="tableData" border stripe :highlight-current-row="true" show-summary>
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <template v-for="(item, index) in tabelHeadeTitle">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 任务弹窗 -->
    <myDialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="handleCloseDia" @diaConfirmBtn="diaConfirmBtn">
      <!-- 表格 -->
      <div class="glo_Table">
        <el-table header-align="center" :data="tableDataDialog" border stripe :highlight-current-row="true" ref="mytable" @row-click="rowclick" @selection-change="handleSelectionChange">
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
          <template v-for="(item, index) in tabelHeadeTitle">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            ></el-table-column>
          </template>
        </el-table>
      </div>
    </myDialog>

    <!-- 其他费用 -->
    <otherFee
      :isShowDialog_otherFee="isShowDialog_otherFee"
      :diaWidth_otherFee="diaWidth_otherFee"
      :dialogTitle_otherFee="dialogTitle_otherFee"
      :otherFeeReqs="otherFeeReqs"
      @handleCloseDia_otherFee="handleCloseDia_otherFee"
      @diaConfirmBtn_otherFee="diaConfirmBtn_otherFee"
    ></otherFee>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
import paging from "@/components/pagings.vue"; //分页组件
import myDialog from "@/components/Dialog.vue";
import otherFee from "@/components/otherFee.vue";

export default {
  inject: ["reload"],
  components: { uploadimgs, paging, myDialog, otherFee },
  data() {
    return {
      diaWidth: "80%",
      dialogTitle: "选择任务",
      isShowDialog: false,

      diaWidth_otherFee: "80%",
      dialogTitle_otherFee: "其他费用",
      isShowDialog_otherFee: false,
      otherFeeReqs: [],

      baseInForm: {
        agentAmount: "",
        allOtherFee: "",
        apportionedCost: "",
        basicFreight: "",
        billingAmount: "",
        billingMethodConfDictId: "",
        billingWeight: "",
        carrierDeptId: "",
        carrierLineId: "",
        contacts: "",
        destAddress: "",
        destContacts: "",
        destPhone: "",
        insuranceFee: "",
        intoStorageId: "",
        invoiceTaxPoint: "",
        isCarrierSettlement: false,
        isIntoStorage: "0",
        isInvoice: "0",
        localPhone: "",
        outboundCarrierId: "",
        outgoingNumber: "",
        outgoingTime: "",
        packageCount: "",
        receiveMethodConfDictId: "",
        receivedAmount: "",
        remarks: "",
        returnAmount: "",
        sendFee: "",
        settlementAmount: "",
        settlementMethodConfDictId: "",
        shouldAmount: "",
        startDeptId: "",
        takeFee: "",
        taskIds: [],
        taxes: "",
        totalFreight: "",
        transferAddress: "",
        transferPhone: "",
        unLoadFee: "",
        unitPrice: "",
        volume: "",
        weight: "",
        netWeight: "",
        grossWeight: "",
      },
      tableData: [],
      tableDataDialog: [],
      tableData2: [],
      rulesA: {
        carrierDeptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        billingMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        // carrierLineId: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        outboundCarrierId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        outgoingNumber: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        receiveMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        startDeptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        settlementMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      CustomerList: [],
      selectTableData: [],
      tabelHeadeTitle: [
        {
          name: "任务编号",
          field: "number",
          width: "190",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "190",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "任务运输方式",
          field: "transportMethodShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输计划",
          field: "transportPlanShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "状态",
          field: "taskStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物",
          field: "huoWu",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customerOrderNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "入仓仓库",
          field: "intoStorageName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外部运输承运商",
          field: "carrierName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发承运商",
          field: "outgoingCarrierName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发承运商网点",
          field: "outgoingDeptName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货时间",
          field: "takeTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "交货日期",
          field: "deliveryTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货地址",
          field: "taskStartAllAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货地址",
          field: "taskEndAllAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发车批次号",
          field: "dispatchNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车牌号",
          field: "carNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "挂车号码",
          field: "trailerNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机",
          field: "driverName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "押运员",
          field: "supercargoName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发车合同号",
          field: "dispatchContractNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货时间",
          field: "loadTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货操作人",
          field: "loadUserName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货时间",
          field: "unloadTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货操作人",
          field: "unloadUserName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "退单状态",
          field: "chargebackStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "退单原因",
          field: "chargebackReason",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "是否回仓",
          field: "returnCangStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回仓原因",
          field: "returnCangReason",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回仓仓库",
          field: "returnCangStorageName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      tabelHeadeTitle2: [
        {
          name: "运单号",
          field: "waybillNumber",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customereOrderNumber",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单部门",
          field: "businessDeptName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "终端部门",
          field: "endDeptName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "业务日期",
          field: "businessDate",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品名",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包装",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "交接方式",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单送货费",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人手机",
          field: "receivePhone",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货省份",
          field: "receiveProvinceName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货详细地址",
          field: "receiveAddress",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回单要求",
          field: "rnRequireName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单重量",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单体积",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单件数",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单运费",
          field: "billingAmount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "代收货款",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "到付金额",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单备注",
          field: "aaa",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      waybillNumber: "",
      send_method_list: [],
      out_going_billing_method_list: [],
      out_going_settlement_method_list: [],
      storageList: [],
      yesOrNoList: [
        {
          name: "是",
          val: "1",
        },
        {
          name: "否",
          val: "0",
        },
      ],
      changeCarrierList: [], //承运商
      CarrierDeptListList2: [], //承运商网点
      CarrierLineLists: [], //承运商线路
      types: "",
    };
  },
  watch: {
    // 外发总额发生变化
    "baseInForm.totalFreight": {
      handler(a, b) {
        // 计算税金
        this.countSJ();
      },
      immediate: false,
    },
    // 税金发生变化
    "baseInForm.taxes": {
      // 计算应付总额
      handler(a, b) {
        this.countYFZE();
      },
      immediate: false,
    },
    // 应付总额发生变化
    "baseInForm.shouldAmount": {
      handler(a, b) {
        // 计算结算金额
        this.countJSJE();
      },
      immediate: false,
    },
    // 其他费用发生变化
    "baseInForm.allOtherFee": {
      handler(a, b) {
        // 计算外发总额
        this.countWFZE();
      },
      immediate: false,
    },
    // 按件数
    "baseInForm.packageCount": {
      handler(a, b) {
        if (a && this.types == "按件数") {
          this.baseInForm.billingWeight = a;
        }
      },
      immediate: false,
    },

    // 按毛重
    "baseInForm.grossWeight": {
      handler(a, b) {
        if (a && this.types == "按毛重") {
          this.baseInForm.billingWeight = a;
        }
      },
      immediate: false,
    },
    // 按净重
    "baseInForm.netWeight": {
      handler(a, b) {
        if (a && this.types == "按净重") {
          console.log("净重", a);
          this.baseInForm.billingWeight = a;
        }
      },
      immediate: false,
    },
    // 按体积
    "baseInForm.volume": {
      handler(a, b) {
        if (a && this.types == "按体积") {
          this.baseInForm.billingWeight = a;
        }
      },
      immediate: false,
    },
    // 计费取值
    "baseInForm.billingWeight": {
      handler(a, b) {
        this.countBaseFee();
      },
      immediate: false,
    },
  },
  created() {},
  mounted() {
    this.baseInForm.outgoingTime = this.$TOOLS.getCurrentTime();

    this.changeCarrier();
    this.getConfDictValDownList("out_going_take_method");
    this.getConfDictValDownList("out_going_settlement_method");
    this.getConfDictValDownList("out_going_billing_method"); //计费方式
    this.getObjectUserDownList("storage"); //网点
  },
  activated() {
    //
    let waybillNumber = this.$route.query.waybillNumber || "";
    console.log("waybillNumber", waybillNumber);
    if (waybillNumber) {
      this.waybillNumber = waybillNumber;
      this.getData();
    }
  },
  destroyed() {},
  methods: {
    // 选择计费方式自动填充计费重量
    changeBILLMethode(e) {
      this.types = "";
      if (e) {
        this.out_going_billing_method_list.forEach((item) => {
          if (item.confDictId == e) {
            let types = item.key;
            this.types = types; //外发计费方式
            if (types == "按毛重") {
              if (this.baseInForm.grossWeight) {
                this.baseInForm.billingWeight = this.baseInForm.grossWeight;
              }
            }
            if (types == "按净重") {
              if (this.baseInForm.netWeight) {
                this.baseInForm.billingWeight = this.baseInForm.netWeight;
              }
            }
            if (types == "按件数") {
              if (this.baseInForm.packageCount) {
                this.baseInForm.billingWeight = this.baseInForm.packageCount;
              }
            }
            if (types == "按体积") {
              if (this.baseInForm.volume) {
                this.baseInForm.billingWeight = this.baseInForm.volume;
              }
            }
            if (types == "按票数") {
              this.baseInForm.billingWeight = 1;
            }
          }
        });
      }
    },
    // 计算基本运费
    countBaseFee() {
      let num1 = this.baseInForm.unitPrice || 0; //单价
      let num2 = this.baseInForm.billingWeight || 0; //计费取值
      this.baseInForm.basicFreight = (num1 * num2).toFixed(2);
      this.countWFZE();
    },
    //计算外发总额
    countWFZE() {
      // 外发总额=基本运费+提货费+送货费+装卸费+其他费用

      let num1 = this.baseInForm.basicFreight || 0; //基本运费
      let num2 = this.baseInForm.takeFee || 0; //提货费
      let num3 = this.baseInForm.sendFee || 0; //送货费
      let num4 = this.baseInForm.unLoadFee || 0; //装卸费
      let num5 = this.baseInForm.allOtherFee || 0; //其他费用

      let array = [num1, num2, num3, num4, num5];
      this.baseInForm.totalFreight = this.$TOOLS.getAddMathNumber(array);
      this.countYFZE();
    },
    //计算税金
    countSJ() {
      // 税金=外发总额*税点
      let num1 = this.baseInForm.totalFreight || 0; //外发总额
      let num2 = this.baseInForm.invoiceTaxPoint || 0; //税点
      let num3 = this.$TOOLS.divide(num2, 100);
      this.baseInForm.taxes = this.$TOOLS.mul(num1, num3).toFixed(2);
      this.countYFZE();
    },
    //计算应付总额
    countYFZE() {
      // 应付总额=外发总额+税金
      let num1 = this.baseInForm.totalFreight || 0; //外发总额
      let num2 = this.baseInForm.taxes || 0; //税金

      let array = [num1, num2];
      this.baseInForm.shouldAmount = this.$TOOLS.getAddMathNumber(array);
      this.countJSJE();
    },
    //计算结算金额
    countJSJE() {
      //  结算金额=应付总额-返点
      let num1 = this.baseInForm.shouldAmount || 0; //应付总额
      let num2 = this.baseInForm.returnAmount || 0; //返点
      this.baseInForm.settlementAmount = this.$TOOLS.sub(num1, num2).toFixed(2);
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(type) {
      this.$COMAPI.getConfDictValDownList(type).then((res) => {
        // 提货方式
        if (type == "out_going_take_method") {
          this.send_method_list = res || [];
        }
        // 外发计费方式
        if (type == "out_going_billing_method") {
          this.out_going_billing_method_list = res || [];
        }
        // 外发结算方式
        if (type == "out_going_settlement_method") {
          this.out_going_settlement_method_list = res || [];
        }
      }); //送货方式
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "storage") {
          this.storageList = res || [];
        }
      }); //获取网点列表
    },
    getData() {
      if (!this.waybillNumber) {
        this.$message.warning("请输入运单号");
        return false;
      }
      let param1 = {
        waybillNumberNoLike: this.waybillNumber,
        transportMethod: "wai_bu_cheng_yun:transport_method",
        outgoingStatus: "wei_wai_fa:outgoing_status",
      };
      // 根据运单号查询任务列表
      this.$API.wtl_getTaskList(param1).then((res) => {
        let datas = res.data.result.data || [];
        if (datas.length == 0) {
          this.$message.warning("查不到对应的外发任务,请确认运单是否已外发");
          return false;
        }
        // outgoingCarrierName
        // baseInForm.outboundCarrierId
        this.changeCarrier(datas[0].carrierName);
        this.isShowDialog = true;
        this.tableDataDialog = res.data.result.data || [];
      });
      // 根据运单号查询运单信息
      let param2 = {
        waybillNumberNoLike: this.waybillNumber,
      };
      this.$API.wtl_getWaybillList(param2).then((res) => {
        this.tableData2 = res.data.result.data || [];
        if (this.tableData2.length > 0) {
          this.baseInForm.billingAmount = this.tableData2[0].billingAmount || 0; //开单运费
          this.baseInForm.agentAmount = this.tableData2[0].agentAmount || 0; //代收货款 receivedAmount
          this.baseInForm.receivedAmount =
            this.tableData2[0].receivedAmount || 0; //到付金额
          console.log(this.baseInForm.receivedAmount);
          // this.baseInForm.settlementMethodConfDictId =
          //   this.tableData2[0].settlementMethod || 0; //代收货款

          this.baseInForm.waybillSplitId =
            this.tableData2[0].waybillSplitId || "";
          this.baseInForm.packageCount = this.tableData2[0].totalCount || "";
          this.baseInForm.grossWeight =
            this.tableData2[0].totalGrossWeight || "";
          this.baseInForm.netWeight = this.tableData2[0].totalNetWeight || "";
          this.baseInForm.volume = this.tableData2[0].totalVolume || "";
          // this.baseInForm.totalVolumeWeight =this.tableData2[0].totalVolumeWeight || "";
          // this.baseInForm.totalWeight =this.tableData2[0].totalWeight || "";
          this.baseInForm.billingWeight =
          this.tableData2[0].totalBillingWeight || "";
        }
      });
    },
    // 保存
    saveConfirm(formName) {
      if (!this.baseInForm.settlementMethodConfDictId) {
        this.$message.error("外发结算方式不能为空").showClose = true;
        return false;
      }
      this.$refs[formName].validate((valid) => {
        console.log(valid, "valid");
        // if (valid) {
        let param = JSON.parse(JSON.stringify(this.baseInForm)) || "";
        // 默认是0
        param.agentAmount = param.agentAmount || 0;
        param.allOtherFee = param.allOtherFee || 0;
        param.apportionedCost = param.apportionedCost || 0;
        param.basicFreight = param.basicFreight || 0;
        param.billingAmount = param.billingAmount || 0;
        param.billingWeight = param.billingWeight || 0;
        param.insuranceFee = param.insuranceFee || 0;
        param.invoiceTaxPoint = param.invoiceTaxPoint || 0;
        param.receivedAmount = param.receivedAmount || 0;
        param.returnAmount = param.returnAmount || 0;
        param.sendFee = param.sendFee || 0;
        param.settlementAmount = param.settlementAmount || 0;
        param.shouldAmount = param.shouldAmount || 0;
        param.takeFee = param.takeFee || 0;
        param.taxes = param.taxes || 0;
        param.totalFreight = param.totalFreight || 0;
        param.unLoadFee = param.unLoadFee || 0;
        param.unitPrice = param.unitPrice || 0;
        param.volume = param.volume || 0;
        param.weight = param.grossWeight || 0;
        param.grossWeight = param.grossWeight || 0;
        param.netWeight = param.netWeight || 0;
        param.packageCount = param.packageCount || 0;
        param.waybillSplitId = param.waybillSplitId || 0;
        let ids = [];
        ids = this.tableData.map((item) => {
          return item.taskId;
        });
        // if (ids.length == 0) {
        //   this.$message.error("外发任务不能为空");
        //   return false;
        // }
        param.taskIds = ids;
        param.otherFeeReqs = this.otherFeeReqs;

        param.isCarrierSettlement = param.isCarrierSettlement ? "1" : "0";
        for (var k in param) {
          if (param[k] === null) {
            param[k] = "";
          }
        }
        this.$API.wtl_addOutgoingBill(param).then((res) => {
          this.$message.success(res.data.message || "新建成功");
          this.cleraPaye();
        });
        // }
      });
    },
    // 清空页面
    cleraPaye() {
      this.tableData = [];
      this.tableData2 = [];
      this.tableDataDialog = [];
      this.waybillNumber = "";
      this.baseInForm = {
        agentAmount: "",
        allOtherFee: "",
        apportionedCost: "",
        basicFreight: "",
        billingAmount: "",
        billingMethodConfDictId: "",
        billingWeight: "",
        carrierDeptId: "",
        carrierLineId: "",
        contacts: "",
        destAddress: "",
        destContacts: "",
        destPhone: "",
        insuranceFee: "",
        intoStorageId: "",
        invoiceTaxPoint: "",
        isCarrierSettlement: false,
        isIntoStorage: "0",
        isInvoice: "0",
        localPhone: "",
        outboundCarrierId: "",
        outgoingNumber: "",
        outgoingTime: "",
        packageCount: "",
        receiveMethodConfDictId: "",
        receivedAmount: "",
        remarks: "",
        returnAmount: "",
        sendFee: "",
        settlementAmount: "",
        settlementMethodConfDictId: "",
        shouldAmount: "",
        startDeptId: "",
        takeFee: "",
        taskIds: [],
        taxes: "",
        totalFreight: "",
        transferAddress: "",
        transferPhone: "",
        unLoadFee: "",
        unitPrice: "",
        volume: "",
        weight: "",
        netWeight: "",
        grossWeight: "",
      };
    },
    // 承运商列表
    changeCarrier(e) {
      this.$COMAPI.changeCarrier(e).then((res) => {
        this.changeCarrierList = res || [];
      });
    },
    // 远程搜索
    getchangeCarrier(e) {
      this.changeCarrier(e);
    },
    // 选择承运商
    changecarrierName3(e) {
      console.log("选择", e);
      this.baseInForm.carrierDeptId = "";
      this.baseInForm.carrierLineId = "";
      if (e) {
        this.changeCarrierList.forEach((item) => {
          if (item.carrierId == e) {
            this.getCarrierDeptList2(e);
            this.CarrierLineList(e);
            this.baseInForm.settlementMethodConfDictId =
              item.settlementMethodConfDictId;
          }
        });
        this.baseInForm.carrierLineId = "";
      } else {
      }
    },
    // 选择网点
    changecarrierDeptId(e) {
      if (e) {
        this.CarrierDeptListList2.forEach((item) => {
          if (item.carrierDeptId == e) {
            this.baseInForm.contacts = item.contacts;
            this.baseInForm.localPhone = item.phone;
          }
        });
      } else {
        this.baseInForm.contacts = "";
        this.baseInForm.localPhone = "";
      }
    },
    // 请选择承运商线路
    changeCarrierLine(e) {
      console.log("e", e);
      //
      let datas = "";
      this.CarrierLineLists.forEach((item) => {
        if (item.carrierLineId == e) {
          datas = item;
        }
      });
      console.log("datas", datas);
      if (datas) {
        // this.baseInForm.contacts = datas.aaaa; //本地联系人
        // this.baseInForm.contacts = datas.aaaa; //本地联系人
        this.baseInForm.destContacts = datas.destContacts || ""; //目的地联系人
        this.baseInForm.destPhone = datas.destPhone || ""; //目的地电话
        this.baseInForm.destAddress =
          datas.destProvinceName + datas.destCityName + datas.destAreaName ||
          ""; //目的地详细地址
        this.baseInForm.transferAddress =
          datas.transferProvinceName +
            datas.transferCityName +
            datas.transferAreaName || ""; //中转地址
        this.baseInForm.transferPhone = datas.transferPhone || ""; //中转电话
      }
    },
    // 获取承运商网点
    getCarrierDeptList(id) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.CarrierDeptListList = res || [];
      });
    },
    // 获取承运商网点
    getCarrierDeptList2(id) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.CarrierDeptListList2 = res || [];
      });
    },
    // 获取承运商线路列表
    CarrierLineList(id) {
      this.$API
        .CarrierLineList({
          carrierId: id,
        })
        .then((res) => {
          this.CarrierLineLists = res.data.result.data || [];
        });
    },

    // =========================================
    // 其他费用部分
    // 查看明细
    otherDetails() {
      this.isShowDialog_otherFee = true;
      if (!this.baseInForm.allOtherFee || this.baseInForm.allOtherFee == 0) {
        this.otherFeeReqs = [];
      }
    },

    // 其他费用关闭
    handleCloseDia_otherFee() {
      this.isShowDialog_otherFee = false;
    },
    // 保存其他费项
    diaConfirmBtn_otherFee(array) {
      this.isShowDialog_otherFee = false;
      this.otherFeeReqs = array || [];
      let num = 0;
      this.otherFeeReqs.forEach((item) => {
        if (item.operationType !== "DEL") {
          num = this.$TOOLS.add(num, item.amount * 1).toFixed(2);
        }
      });
      this.baseInForm.allOtherFee = num;
    },
    // 其他费用部分
    // =========================================

    handleCloseDia() {
      this.isShowDialog = false;
    },

    diaConfirmBtn() {
      if (this.selectTableData.length < 1) {
        this.$message.error("请选择任务");
        return false;
      }
      this.tableData = JSON.parse(JSON.stringify(this.selectTableData));
      this.isShowDialog = false;

      this.baseInForm.outboundCarrierId = this.tableData[0].carrierId || "";
      let taskId = this.tableData[0].taskId || "";
      this.baseInForm.carrierDeptId =
        this.tableData[0].outgoingCarrierDeptId || "";

      // 获取承运商网点
      // this.getCarrierDeptList2(this.baseInForm.outboundCarrierId);
      this.$COMAPI
        .CarrierDeptList(this.baseInForm.outboundCarrierId)
        .then((res) => {
          this.CarrierDeptListList2 = res || [];
          this.CarrierDeptListList2.forEach((item) => {
            if (item.carrierDeptId == this.baseInForm.carrierDeptId) {
              this.baseInForm.contacts = item.contacts;
              this.baseInForm.localPhone = item.phone;
            }
          });
        });
      // 获取承运商线路
      this.CarrierLineList(this.baseInForm.outboundCarrierId);
      // 获取任务货物明细
      this.getGoodsNameDetails(taskId);

      // let arrs = JSON.parse(JSON.stringify(this.tableData)) || [];
      // console.log(arrs, "arrs");
      // let newArrs = [];

      // let tids = arrs.map((item) => {
      //   return item.taskId;
      // });
      // console.log("tids", tids);

      // if (arrs.length > 0) {
      //   this.selectTableData.forEach((item) => {
      //     if (tids.indexOf(item.taskId) == -1) {
      //       newArrs.push(item);
      //     }
      //   });
      //   arrs = [...arrs, ...newArrs];
      // } else {
      //   arrs = [...arrs, ...this.selectTableData];
      // }
      // console.log("arrs", arrs);
      // this.tableData = arrs;
    },

    // 查看任务货物明细:
    getGoodsNameDetails(taskId) {
      this.$API.wtl_getTaskItems({ taskId: taskId }).then((res) => {
        let goodsNameData = res.data.result || [];
        console.log("goodsNameData", goodsNameData);
        let packageCounts = 0; //件数
        let weights = 0; //外发重量
        let volumes = 0; //外发体积
        let billingWeights = 0; //计费取值
        if (goodsNameData.length > 0) {
          goodsNameData.forEach((item) => {
            packageCounts += item.packageCout * 1;
            weights += item.grossWeight * 1;
            volumes += item.volume * 1;
            billingWeights += item.billingWeight * 1;
          });

          this.baseInForm.packageCount = packageCounts.toFixed(2);
          this.baseInForm.weight = weights.toFixed(2);
          this.baseInForm.volume = volumes.toFixed(2);
          this.baseInForm.billingWeight = billingWeights.toFixed(2);
        }
      });
    },
  },
};
</script>
<style scoped lang='less'>
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.disFlex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.formbox {
  padding: 10px 30px 30px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }

  // .glo_formBox {
  //   .teSu {
  //     display: flex;
  //     width: 30%;
  //     min-width: 360px;
  //   }
  // }
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}

.topBtns {
  margin: 0 30px;
  height: 50px;
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.twoSelect {
  display: flex;
}

.tbTit {
  font-weight: bold;
  margin-bottom: 8px;
}
</style>